import React, { useState, useEffect, useRef } from 'react';
import { Dispatch } from 'redux';
import { useSelector } from 'react-redux';
import { AppState } from '../store/';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

import { fetchKeywordDataAction } from '../store/chatmessage/actions';
import styled from 'styled-components';
import { chatTheme } from '../styles/theme';
import { media } from '../styles/media';

const ChatContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
`;
const ChatInput = styled.input`
  padding: 5px;
  border: none;
  width: 93%;
`;

const SendIcon = styled(FontAwesomeIcon)<{ onClick: () => void }>`
  width: 7%;
  font-size: 20px;
  cursor: pointer;
  color: ${chatTheme.colors.secondary};

  ${media.phone} {
    margin-right: 15px;
  }
`;
interface IProps {
  // onFetchKeywordData: typeof fetchKeywordDataAction;
  mainColor: string;
  dispatch: Dispatch;
}

const ChatBotFreeInput: React.FC<IProps> = props => {
  const dispatch = props.dispatch;
  const chatbasedata = useSelector((state: AppState) => state.chatBaseData);
  const [freeWord, setFreeWord] = useState('');
  const inputEl = useRef<HTMLInputElement>(null);
  const ENTER_KEY = 13;

  useEffect(() => {
    if (inputEl && inputEl.current) {
      inputEl.current.focus();
    }
  }, []);

  const handleSubmit = (e: React.KeyboardEvent) => {
    const key = e.keyCode;
    if (key === ENTER_KEY && freeWord !== '') {
      dispatch(fetchKeywordDataAction(freeWord, chatbasedata));
      setFreeWord('');
    }
  };
  const handleClickSubmit = () => {
    if (freeWord !== '') {
      dispatch(fetchKeywordDataAction(freeWord, chatbasedata));
      setFreeWord('');
    }
  };
  return (
    <ChatContainer>
      <ChatInput
        ref={inputEl}
        value={freeWord}
        onChange={e => setFreeWord(e.target.value)}
        onKeyUp={handleSubmit}
      />
      <SendIcon
        icon={faPaperPlane}
        style={{ color: props.mainColor }}
        onClick={handleClickSubmit}
      />
    </ChatContainer>
  );
};

export default ChatBotFreeInput;
